module.exports = __webpack_public_path__ + "media/images/report_areas/sign_here_left-8e2b56540126b80d91fb1045ebfb1c8d.png";